import { useState, useCallback } from 'react';
import { gamesApi } from '../api/games';
import { useWalletStore } from '../store/walletStore';
import { ApiError } from '../api/functionsClient';
import type { SlotResult } from '../types';

export function useSlotMachine() {
  const [spinning, setSpinning] = useState(false);
  const [result, setResult] = useState<SlotResult | null>(null);
  const [error, setError] = useState<string | null>(null);
  const setBalance = useWalletStore((s) => s.setBalance);

  const spin = useCallback(
    async (betAmount: number) => {
      setSpinning(true);
      setError(null);
      try {
        const res = await gamesApi.playSlot(betAmount);
        setResult(res);
        setBalance(res.balanceAfter);
        return res;
      } catch (err) {
        setError(err instanceof ApiError ? err.message : 'Spin failed');
        throw err;
      } finally {
        setSpinning(false);
      }
    },
    [setBalance],
  );

  return { spin, spinning, result, error };
}
